import { getIsSpanishPilot } from '../../../../services/API'
import { ASR_CHECK_STORY_IDS } from '../../../../constants/asrCheckStories'

// Utility function to get the appropriate ASR story ID based on language
export const getASRStoryId = (userData) => {
    // GT-413: the check story follows the language its prompts are spoken in, so a student is
    // never told in English to read the Spanish phrase (calibration, or a student who switched
    // the support language to English). Same rule as the copy strings: App.setBilingualMode uses
    // bilingualLocale while bilingual mode is on, and the session locale otherwise. tutorInSpanish
    // students get the Spanish check through bilingualLocale, which login sets to es-mx.
    const promptLocale = userData.bilingualMode && userData.bilingualLocale
        ? userData.bilingualLocale
        : userData.locale
    const isSpanish = promptLocale === 'es-mx' || getIsSpanishPilot()

    // Ready Module ASR story IDs live in constants/asrCheckStories so the login-time
    // tutor-history read can exclude them by the same values.
    return isSpanish
        ? ASR_CHECK_STORY_IDS.ES_MX // Spanish ASR story
        : ASR_CHECK_STORY_IDS.EN_US // English ASR story
}
